import Vue from 'vue'
import $api from '@/shared/services/api'
import loading from '@/shared/plugins/loading'

const TTL_DOMINIO = 5 * 60 * 1000

const chaveCacheDominio = () => 'dominio_dados_' + window.location.host

function leCacheDominio(){
    try {
        const bruto = localStorage.getItem(chaveCacheDominio())
        if(!bruto){
            return null
        }
        const cache = JSON.parse(bruto)
        if(!cache || !cache.ts || (Date.now() - cache.ts) > TTL_DOMINIO){
            return null
        }
        return cache.data
    } catch(e){
        return null
    }
}

function gravaCacheDominio(data){
    try {
        localStorage.setItem(chaveCacheDominio(), JSON.stringify({ data, ts: Date.now() }))
    } catch(e){
        return
    }
}

function aplicaRedirectProtocolo(dominio){
    if(dominio.utiliza_https == 1 && window.location.protocol == 'http:'){
        loading.show()
        location.href = location.href.replace('http', 'https')
    }
    if(dominio.utiliza_https == 0 && window.location.protocol == 'https:'){
        loading.show()
        location.href = location.href.replace('https', 'http')
    }
}

export default {
    namespaced: true,
    state: {
        dominio: null,
    },
    getters: {
        pegaDominio(state){
            return state.dominio
        },
    },
    mutations: {
        atualizaDominio(state, dominio){
            state.dominio = dominio
        },
    },
    actions: {
        async carregaDominio({ commit }){
            const cacheDados = leCacheDominio()
            if(cacheDados && cacheDados.Dominio){
                aplicaRedirectProtocolo(cacheDados.Dominio)
                commit('atualizaDominio', cacheDados.Dominio)
                return { status: 'success', data: cacheDados }
            }
            const retorno = await $api.cGet(Vue.prototype.$urlBase + '/dominios/dados')
            if(retorno.status == 'success'){
                aplicaRedirectProtocolo(retorno.data.Dominio)
                commit('atualizaDominio', retorno.data.Dominio)
                gravaCacheDominio(retorno.data)
            }else{
                Vue.prototype.$dialog.error(retorno.message || 'Oops! Ocorreu algum erro no sistema.')
            }
            return retorno
        }
    },
}
